import { Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Badge from "@material-ui/core/Badge";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import MenuIcon from "@material-ui/icons/Menu";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { getNotifications } from "../redux/actions/dataActions";
import { logoutUser } from "../redux/actions/userActions";


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: drawerWidth,
  },
  menuButton: { marginRight: "0" },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  list: {
    justifyContent: "center",
  },
  listItem: {
    textAlign: "center",
  },
  windowButton: {
    margin: "0",
  },
}));

function Navbar(props) {
  const { authenticated } = props.user;
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const { notifications } = props.data;

  const handleDrawerOpen = () => {
    props.getNotifications();
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    console.log("Logging out");
    props.logoutUser();
    props.history.push("/");
    handleDrawerClose();
  };

  let signup;
  let login;
  let home;
  let menuButton;
  let kada;

  if (authenticated) {
    kada = (
      <div style={{ width: "50%", paddingLeft: "12px" }}>
        <Typography variant="h4" noWrap className={classes.title}>
          <Link to="/curriculum" style={{ textDecoration: "none" }}>
            <span
              style={{
                color: "white",
                fontFamily: "sans-serif",
                fontWeight: 700,
              }}
            >
              Career
            </span>
            <span
              style={{
                color: "#e9a746",
                fontFamily: "sans-serif",
                fontWeight: 700,
              }}
            >
              X
            </span>
          </Link>
        </Typography>
      </div>
    );
    menuButton = (
      <IconButton
        color="inherit"
        aria-label="open drawer"
        onClick={handleDrawerOpen}
        edge="end"
        style={{ float: "right" }}
        className={clsx(classes.menuButton, open && classes.hide)}
      >
        <MenuIcon />
      </IconButton>
    );

    home = (
      <Button color="inherit" component={Link} to="/">
        Home
      </Button>
    );
  } else {
    kada = (
      <div style={{ width: "50%", paddingLeft: "12px" }}>
        <Typography variant="h4" noWrap className={classes.title}>
          <Link to="/" style={{ textDecoration: "none" }}>
            <span
              style={{
                color: "white",
                fontFamily: "sans-serif",
                fontWeight: 700,
              }}
            >
              Career
            </span>
            <span
              style={{
                color: "#e9a746",
                fontFamily: "sans-serif",
                fontWeight: 700,
              }}
            >
              X
            </span>
          </Link>
        </Typography>
      </div>
    );
    login = (
      <Button color="inherit" component={Link} to="/login">
        Login
      </Button>
    );
    signup = (
      <Button color="inherit" component={Link} to="/signup">
        Signup
      </Button>
    );
  }

  return (
    <div>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar className="nav-container" style={{ margin: "0" }}>
          {kada}
          {login}
          {signup}
          <div style={{ width: "50%" }}>{menuButton}</div>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="right"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <Typography variant="h4"></Typography>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <List className={classes.list}>
          <ListItem
            className={classes.listItem}
            button
            key={"All Programs"}
            component={Link}
            to="/programs"
            onClick={handleDrawerClose}
          >
            <ListItemText primary={"All Programs"} />
          </ListItem>
          <ListItem
            className={classes.listItem}
            button
            key={"Profile"}
            component={Link}
            to="/profile"
            onClick={handleDrawerClose}
          >
            <ListItemText primary={"My Profile"} />
          </ListItem>
          <ListItem
            className={classes.listItem}
            button
            key={"Curriculum"}
            component={Link}
            to="/curriculum"
            onClick={handleDrawerClose}
          >
            <ListItemText primary={"My Program"} />
          </ListItem>
          <ListItem
            className={classes.listItem}
            button
            key={"Notifications"}
            component={Link}
            to="/notifications"
            onClick={handleDrawerClose}
            style={{display:'flex', justifyContent:"center"}}
          >
            <Badge color = "secondary" badgeContent={notifications.length}>
              <ListItemText primary={"My Notifications"} />
            </Badge>
          </ListItem>
          <ListItem
            className={classes.listItem}
            button
            key={"Milestone"}
            component={Link}
            to="/milestone"
            onClick={handleDrawerClose}
          >
            <ListItemText primary={"Progress Milestone"} />
          </ListItem>
          <ListItem
            className={classes.listItem}
            button
            key={"Connect"}
            component={Link}
            to="/connect"
            onClick={handleDrawerClose}
          >
            <ListItemText primary={"Connect with Kada"} />
          </ListItem>
          <ListItem
            className={classes.listItem}
            button
            key={"Logout"}
            component={Link}
            onClick={handleLogout}
            to="/"
          >
            <ListItemText primary={"Logout"} />
          </ListItem>
        </List>
      </Drawer>
    </div>
  );
}

Navbar.propTypes = {
  getNotifications: PropTypes.func.isRequired,
  logoutUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  data: state.data,
});

export default withRouter(connect(mapStateToProps, { getNotifications, logoutUser })(Navbar));
